<template>
  <div class='agreement-item'>
    <div class="row">
      <div class="col-12 col-md-1 agreement-item-highlight">
        <img src="/static/free-icons/contract-icon-19930.png" width="60px" height="60px">
      </div>
      <div class="col-q12 col-md-11">
        <span class="agreement-item-highlight">
          {{ agreement.title }}
        </span>
        číslo {{ agreement.reference }}
        ze dne {{ human_readable_date(agreement.created_at) }}
        <span>
          <a :href="'/api/agreements/' + agreement.id">
            <i class="fa fa-download" aria-hidden="true"></i> Stáhnout (PDF)
          </a>
        </span>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-1 agreement-item-highlight">
      </div>
      <div class="col-12 col-md-6">
        <div class="document-preview">
        <iframe
          :src="'/api/agreements/' + agreement.id + '?inline'"
          width="100%"
          height="100%"
          frameborder="0"
          style="border:1px solid #ddd;border-radius:8px;"
          allow="autoplay"
          :key="iframeUpdateTrigger"
        ></iframe>

        </div>
      </div>
      <div class="col-12 col-md-5">
        <div v-if="agreement.cancelled_at" class="alert alert-danger" role="alert">
          ❌ zrušená
        </div>
        <div v-else>
          <div v-if="agreement.signed_at" class="alert alert-success" role="alert">
            ✅ platná a podepsaná
          </div>
          <div v-else class="alert alert-info" role="alert">
            ⏳ čeká na podpis
          </div>
        </div>

        <section v-for="signature in agreement.signatures" class="alert alert-secondary" role="alert">
          Podpis {{ signature.sequence + 1 }}: {{ signature.caption }}
          <div v-if="signature.signed_timestamp">
            ✅ <span style="font-family:cursive;">{{ signature.signed_name }}</span>
            <br/>
            <small>
              {{ human_readable_date_time(signature.signed_timestamp) }}
            </small>
          </div>
          <div v-else>
            ⏳ ještě nepodepsáno
            <div v-if="signature.allow_customer == 1">
              <!-- Button "podepsat dokument" -->
              <button class="btn btn-success" id="btn-podepsatdokument" v-on:click="podepsatDokument(signature.sequence, signature.caption)">
                <i class="fa fa-pencil" aria-hidden="true"></i> PODEPSAT DOKUMENT
              </button>
            </div>
          </div>
        </section>
      </div>
    </div>

    <div class="row" v-if="displayError">
      <div class="col-lg-12">
        <div class="alert alert-danger" role="alert">
          <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ displayError }}
        </div>
      </div>
    </div>

    <!-- Modal "ověření telefonního čísla" -->
    <div v-if="showVerifyPhoneNumber">
      <verifyPhoneNumber
        :index="defaultSmluvniNumberIdx"
        @finished="finishedPhoneNumberVerification()"
        @verified="successfulPhoneNumberVerification()"
      />
    </div>

    <!-- Modal "podepsat smlouvu" -->
    <agreementSign v-if="podpisovyModalShown"
     :podpisProps="podpisovyModalProps"
     v-on:modal-hidden="podpisovyModalShown = undefined"
     v-on:document-sign-finished="iframeUpdateTrigger = !iframeUpdateTrigger; $emit('reload-all-agreements')"
    />
  </div>
</template>

<script>
import SessionResource from '../backend-resources/session-resource';
import AgreementSign from '@/components/AgreementSign'
import VerifyPhoneNumber from '@/components/VerifyPhoneNumber';
import moment from 'moment';

export default {
  name: 'agreement',
  data: () => {
    return {
      showVerifyPhoneNumber: false,
      defaultSmluvniNumberIdx: 0,
      podpisovyModalShown: false,
      podpisovyModalProps: undefined,
      displayError: null,
      iframeUpdateTrigger: false,
    }
  },
  props: [ 'agreement' ],
  components: {
    agreementSign: AgreementSign,
    verifyPhoneNumber: VerifyPhoneNumber
  },
  created: function() {
    const phoneNumbers = this.$store.state.customerInfo.phoneNumbers;
    this.defaultSmluvniNumberIdx = phoneNumbers.findIndex((pn) => pn.typ_sml === 1);
  },
  methods: {
    human_readable_date: function (yyyymmdd) {
      return moment(yyyymmdd).format('D.M.Y')
    },
    human_readable_date_time: function (yyyymmdd) {
      return moment(yyyymmdd).format('D.M.Y H:mm')
    },
    podepsatDokument: function(seq, caption) {
      const phoneNumbers = this.$store.state.customerInfo.phoneNumbers
      const verified = phoneNumbers[this.defaultSmluvniNumberIdx].verified_as_of !== null

      this.podpisovyModalProps = {
        id: this.agreement.id,
        title: this.agreement.title,
        seq,
        caption
      }

      if (!verified) {
        this.showVerifyPhoneNumber = true
      } else {
        this.podpisovyModalShown = true
      }
    },
    reloadCustomerInfo: function () {
      console.log('reloadCustomerInfo')
      const sr = new SessionResource()
      sr.get().then((response) => {
        this.$store.commit('loginSuccess', response.data)
      })
    },
    finishedPhoneNumberVerification: function () {
      this.showVerifyPhoneNumber = false
    },
    successfulPhoneNumberVerification: function () {
      this.reloadCustomerInfo()
      this.showVerifyPhoneNumber = false
      this.podpisovyModalShown = true
    },
  },

}
</script>

<style scoped>
.agreement-item {
  padding-left: 15px;
  margin-bottom: 40px;
  padding-top: 10px;
  padding-right: 17px;
  min-height: 200px;
  margin-bottom: 20px;
  border-style: solid;
  border-width: 1px;
  border-color: #e7e7e7;
  border-radius: 4px;
  position: relative;
}
.document-preview {
  /* width: 500px; */
  /* max-width: 85vw; */
  height: 75vh;
  background-color: #e7e7e7;
}
.agreement-item-highlight {
  color:#538ebe;
  font-weight: bold;
}
.row {
  margin-bottom: 5px;
  justify-content: center;
}
#btn-podepsatdokument {
  margin-top: 5px;
  width: auto;
  height: auto;
  padding: 1em;
  padding-left: 3em;
  padding-right: 3em;
}
</style>



// WEBPACK FOOTER //
// Agreement.vue?d2af285c